<template>
  <v-toolbar color="grey lighten-2" flat dense>
    <!-- <v-btn fab small color="green" dark>
      <v-icon dark>mdi-account</v-icon>
    </v-btn>-->

    <v-btn
      :color="getColorStatusAvatar()"
      fab
      dark
      x-small
      v-if="getColorStatusAvatar() === 'error'"
    >
      <v-icon>mdi-account</v-icon>
    </v-btn>
    <v-menu v-if="getColorStatusAvatar() !== 'error'" offset-y>
      <template v-slot:activator="{ on }">
        <v-btn :color="getColorStatusAvatar()" fab dark x-small v-on="on">
          <v-icon v-if="getColorStatusAvatar() == 'success'"
            >mdi-account</v-icon
          >
          <v-icon v-else>mdi-coffee</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in filterPausas()"
          :key="index + item.nome"
        >
          <v-list-item-title>
            <v-checkbox
              v-model="pausaStatus[index].value"
              :label="item.nome"
              color="warning"
              :value="true"
              @change="pausaEvent(pausaStatus[index])"
              hide-details
            ></v-checkbox>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <Relogio
      :color="getColorStatus()"
      :datainicial="lastQueueEvent ? lastQueueEvent : new Date()"
    />

    <!-- <span class="green--text ml-2">00:45:12</span> -->
    <v-spacer></v-spacer>
    <span :style="getColorStatus()" class="mr-1">{{ getStatus(status) }}</span>
  </v-toolbar>
</template>
   
<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
import Relogio from "../Relogio";

export default {
  name: "Agente-Status",
  components: {
    Relogio,
  },
  props: {
    title: { type: String, default: "Title" },
  },
  data: () => ({
    ip: JSON.parse(localStorage.getItem("config")).servidor,
    lastQueueEvent: null,
  }),
  created() {
    this.getPausas();
  },
  methods: {
    getStatus(status) {
      if (status == "success") {
        return this.t("indisponivel");
      }
      if (this.user.status == 1) {
        return this.t("disponivel");
      }
      if (this.user.status == 5) {
        return this.t("indisponivel");
      }
      if (this.user.status == 2 || this.user.status == 3) {
        return this.t("ocupado");
      }
      return status;
    },
    async getPausas() {
      let retorno = await this.getDefault("/api/v3/pausa?max=-1&page=1");
      if (retorno.dados) this.addPausas(retorno.dados);
    },
    ...mapActions("xc", ["addPausas", "getDefault"]),
    ...mapActions("auth", [
      "queueAdd",
      "queueRemove",
      "queuePause",
      "queueUnpause",
    ]),
    pausaEvent(data) {
      if (data.value != null) {
        for (let pausa of this.pausaStatus) {
          if (data.nome === pausa.nome) {
            pausa.value = true;
          } else {
            pausa.value = false;
          }
        }
        this.queuePause({ motivo: data.nome, user: this.user });
      } else {
        this.queueUnpause({ user: this.user });
      }
    },

    getColorStatus() {
      if (this.user.status === 1 || this.user.status === 2) {
        return "color:green";
      }
      if (this.user.status === 10) {
        return "color:#FFAB40";
      }
      if (
        this.user.status !== 1 &&
        this.user.status !== 2 &&
        this.user.status !== 10
      ) {
        return "color:red";
      }
    },
    getColorStatusAvatar() {
      if (this.user.status === 1 || this.user.status === 2) {
        return "success";
      }
      if (this.user.status === 10) {
        return "#FFAB40";
      }
      if (
        this.user.status !== 1 &&
        this.user.status !== 2 &&
        this.user.status !== 10
      ) {
        return "error";
      }
      if (this.user.status === 5) {
        return "error";
      }
      return "error";
    },
    filterPausas() {
      return this.pausas.filter((p) => {
        if (p.editavel != true) return false;
        if (p.fila && this.user.filas.findIndex((f) => f.fila == p.fila) == -1)
          return false;
        return true;
      });
    },
  },
  computed: {
    ...mapState("xc", {
      pausas: (state) => state.pausas,
    }),
    ...mapState("auth", {
      user: (state) => state.user,
      status: (state) => state.status,
      oldStatus: (state) => state.oldStatus,
      filas: (state) => state.user.filas,
      pausaMotivo: (state) => state.user.motivoPausa,
      userStatus: (state) => state.user.status,
      userOldStatus: (state) => state.user.oldStatus,
    }),
    pausaStatus: function () {
      return this.filterPausas();
    },
  },
  watch: {
    pausaMotivo(nw) {
      if (nw) {
        let auxPausas = this.pausaStatus.find((p) => p.nome === nw);
        if (auxPausas) {
          auxPausas.value = true;
        }
      }
    },
    userStatus(nw) {
      //caso fique indisponivel vamos remover as pausas
      if (nw) {
        this.lastQueueEvent = new Date();
        if (nw !== 10 && nw !== 1) {
          for (let p of this.pausaStatus) {
            p.value = false;
          }
        }
      }
    },
  },
};
</script>